import React from 'react';

function Label({ type, customText, resourcedTexts }) {
    const [className, resourcedText] = getClassAndResourceFromType(type, resourcedTexts);

    /** Note that HTML changes should also be done here: /src/organisms/relatedProducts/label/label.hbs
     * ...since the styling is shared. **/
    return <div className={`sfr-label ${className}`}>{customText ? customText : resourcedText}</div>;
}

function getClassAndResourceFromType(labelType, resourcedTexts) {
    const className = 'sfr-label';

    switch (labelType.toLowerCase()) {
        case 'aps.event':
            return [className + '--event', resourcedTexts.event];
        case 'aps.informationmeeting':
            return [className + '--information-meeting', resourcedTexts.informationMeeting];
        case 'aps.customtraining':
            return [className + '--custom-training', resourcedTexts.customTraining];
        case 'aps.studytrip':
            return [className + '--study-trip', resourcedTexts.studyTrip];
        case 'aps.webinar':
            return [className + '--webinar', resourcedTexts.webinar];
        case 'aps.training':
            return [className + '--training', resourcedTexts.training];
        case 'aps.trainingproductsectionoverviewpage':
            return [className + '--training-overview', resourcedTexts.trainingOverview];
        case 'aps.download':
        case 'aps.license':
        case 'aps.licensewithvariants':
            return [className + '--licence', resourcedTexts.licence];
        case 'aps.licenseproductsectionoverviewpage':
            return [className + '--licence-overview', resourcedTexts.licenceOverview];
        case 'aps.generalcontentpage':
            return [className + '--general', resourcedTexts.contentGeneral];
        case 'aps.articlepage':
            return [className + '--article', resourcedTexts.contentArticle];
        case 'aps.blogpostpage':
            return [className + '--blog', resourcedTexts.contentBlog];
        case 'aps.podcastcontentpage':
            return [className + '--podcast', resourcedTexts.contentPodcast];
        case 'aps.videocontentpage':
            return [className + '--video', resourcedTexts.contentVideo];
        case 'aps.webinarcontentpage':
            return [className + '--webinar', resourcedTexts.contentWebinar];
        case 'aps.newsarticlepage':
            return [className + '--news', resourcedTexts.contentNews];
        case 'aps.userexperiencepage':
            return [className + '--user-experience', resourcedTexts.contentUserExperience];
        case 'aps.whitepaperpage':
            return [className + '--white-paper', resourcedTexts.contentWhitePaper];
        case 'aps.contentmanual':
            return [className + '--manual', resourcedTexts.contentManual];
        case 'offer':
            return [className + '--offer', null];
        case 'date':
            return [className + '--date', null];
        case 'level':
            return [className + '--level', null];
        default:
            return [null, null];
    }
}

export { Label };
